export interface PnlPurchaseRate {
  rate: number;
  effective_date: string;
  rate_type: string;
  currency_pair: string;
  bank_account_id?: string | null;
}

export function getUnscopedBankRateAsOf(
  rates: PnlPurchaseRate[],
  pair: string,
  date: string
): number | null {
  const found = rates.find(
    (rate) =>
      rate.currency_pair === pair &&
      rate.rate_type === "bank_rate" &&
      !rate.bank_account_id &&
      rate.effective_date <= date
  );
  return found ? Number(found.rate) : null;
}

export function convertPurchaseAtBankRate(
  amount: number,
  sourceCurrency: string,
  displayCurrency: string,
  date: string,
  rates: PnlPurchaseRate[]
): number | null {
  if (sourceCurrency === displayCurrency) return amount;

  const direct = getUnscopedBankRateAsOf(
    rates,
    `${sourceCurrency}/${displayCurrency}`,
    date
  );
  if (direct && direct !== 0) return amount * direct;

  const inverse = getUnscopedBankRateAsOf(
    rates,
    `${displayCurrency}/${sourceCurrency}`,
    date
  );
  if (inverse && inverse !== 0) return amount / inverse;

  if (sourceCurrency !== "ETB" && displayCurrency !== "ETB") {
    const sourceToEtb = getUnscopedBankRateAsOf(
      rates,
      `${sourceCurrency}/ETB`,
      date
    );
    const targetToEtb = getUnscopedBankRateAsOf(
      rates,
      `${displayCurrency}/ETB`,
      date
    );
    if (sourceToEtb && targetToEtb) return (amount * sourceToEtb) / targetToEtb;
  }

  return null;
}